import api, { getErrorMessage } from './apiClient';

export async function submitQuestionFeedback(questionId, payload) {
  try {
    const res = await api.post(`/api/questions/${questionId}/feedback/`, payload);
    return res?.data;
  } catch (err) {
    const msg = getErrorMessage(err);
    const e = new Error(msg);
    e.cause = err;
    throw e;
  }
}

